import { Popover as MuiPopover, PopoverProps } from '@mui/material'

import { styled, Z_INDEX } from '../../theme'
import { MsdkStyledComponent } from '../../utils'

// eslint-disable-next-line import/no-unused-modules
export const Popover: MsdkStyledComponent<PopoverProps> = styled(MuiPopover)`
  z-index: ${Z_INDEX.fixed};
`
